// import { takeEvery  } from "redux-saga/effects";

// import {
//   LEADS_CHECK_FOR_EXISTING_CLIENT_BEGIN
// } from './constants'

export default function* leads() {
  // Here you put the sagas of Leads module, here's an example, you can delete it after placing the first actual sagas
  //yield takeEvery(LEADS_CHECK_FOR_EXISTING_CLIENT_BEGIN, checkForExistingClient);
}